<template>
    <div class="box">
        <p class="mb-1 has-text-weight-bold">
            {{ translate("admin_results.selected_options") }}
        </p>

        <div>
            <span class="icon">
                <i v-if="store.resultOptions.fullList" class="fas fa-check-circle has-text-success" />
                <i v-else class="fas fa-times-circle has-text-danger" />
            </span>
            <span>{{ translate("admin_results.show_full_list_results") }}</span>
        </div>

        <div v-if="store.resultOptions.roundRobinWithTwo3rdPlaces">
            {{ translate("bracket_type.round_robin") }}:
            <span class="icon">
                <i class="fas fa-check-circle has-text-success" />
            </span>
            <span>{{ translate("admin_results.report_two_3rd_places") }}</span>
        </div>

        <div v-if="store.resultOptions.doubleEliminationWrestlingRules">
            {{ translate("admin_results.double_elimination") }}:
            <span class="icon">
                <i class="fas fa-check-circle has-text-success" />
            </span>
            <span>{{ translate("admin_results.wrestling_regulations") }}</span>

            <span v-if="store.resultOptions.doubleElimination5thPlaceCalculation">
                +
                <span>
                    {{
                        translate(
                            "admin_results.doubleElimination5thPlaceCalculation." +
                                store.resultOptions.doubleElimination5thPlaceCalculation,
                        )
                    }}
                </span>
            </span>
        </div>

        <div v-if="store.resultOptions.twoPoolsWrestlingRules">
            {{ translate("admin_results.two_pools_bracket") }}:
            <span class="icon">
                <i class="fas fa-check-circle has-text-success" />
            </span>
            <span>{{ translate("admin_results.wrestling_regulations") }}</span>

            <span v-if="store.resultOptions.twoPools5thPlaceCalculation">
                +
                <span>
                    {{ translate("admin_results.doubleElimination5thPlaceCalculation." + store.resultOptions.twoPools5thPlaceCalculation) }}
                </span>
            </span>
        </div>

        <div v-if="store.resultOptions.repechageByFinalistsWrestlingRules">
            {{ translate("bracket_type.repechage_by_finalists") }}:
            <span class="icon">
                <i class="fas fa-check-circle has-text-success" />
            </span>
            <span>{{ translate("admin_results.wrestling_regulations") }}</span>

            <span v-if="store.resultOptions.repechageByFinalists5thPlaceCalculation">
                +
                <span>
                    {{
                        translate(
                            "admin_results.doubleElimination5thPlaceCalculation." +
                                store.resultOptions.repechageByFinalists5thPlaceCalculation,
                        )
                    }}
                </span>
            </span>
        </div>

        <div>
            <span class="icon">
                <i class="fas fa-sort"></i>
            </span>
            <span> {{ translate("common.sort") }}: {{ getSortingTranslation }} </span>
        </div>

        <div v-if="canChangeOptions" class="button is-small mt-3" @click="changeOptions">
            <span class="icon">
                <i class="fas fa-wrench"></i>
            </span>
            <span>{{ translate("admin_results.change_options") }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { eventBus, OPEN_COMPETITOR_RESULTS_OPTIONS_MODAL } from "../eventBus";
    import { useCompetitorResultsOptionsStore } from "./competitorResultsOptionsStore";
    import { computed } from "vue";
    import { translate } from "../../Common/translations";

    withDefaults(defineProps<{ canChangeOptions?: boolean }>(), {
        canChangeOptions: true,
    });

    const store = useCompetitorResultsOptionsStore();

    function changeOptions() {
        eventBus.$emit(OPEN_COMPETITOR_RESULTS_OPTIONS_MODAL);
    }

    const getSortingTranslation = computed(() => {
        if (store.resultOptions.resultsSorting === "categoriesOrder") {
            return translate("admin_results.sort_by_category_order");
        } else {
            return translate("admin_results.sort_by_category_end_time");
        }
    });
</script>

<style scoped></style>
